import * as actions from './organizationUser.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { OrganizationUserModel } from '@smarttask-common/src/lib/models/OrganizationUser/OrganizationUserModel';

export const organizationUserAdapter = createEntityAdapter<OrganizationUserModel>({
    selectId: (x) => x.user_id,
});
export interface OrganizationUserState extends EntityState<OrganizationUserModel> {
    selected_user_id: number;
}

export const initialState: OrganizationUserState = organizationUserAdapter.getInitialState({
    selected_user_id: undefined,
});

export function OrganizationUserReducers(state: OrganizationUserState = initialState, action: actions.OrganizationUserActions) {
    switch (action.type) {
        case actions.OrganizationUserActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_user_id: action.selected_user_id };
            //console.log(state);
            return state;

        case actions.OrganizationUserActionTypes.ADD_USER:
            return organizationUserAdapter.addOne(action.user, state);

        case actions.OrganizationUserActionTypes.ADD_USERS:
            return organizationUserAdapter.addMany(action.users, state);

        case actions.OrganizationUserActionTypes.UPSERT_USER:
            return organizationUserAdapter.upsertOne(action.user, state);

        case actions.OrganizationUserActionTypes.UPSERT_USERS:
            return organizationUserAdapter.upsertMany(action.users, state);

        case actions.OrganizationUserActionTypes.UPDATE_USER:
            return organizationUserAdapter.updateOne(action.user, state);

        case actions.OrganizationUserActionTypes.UPDATE_USERS:
            return organizationUserAdapter.updateMany(action.users, state);

        case actions.OrganizationUserActionTypes.DELETE_USER:
            // if(state.selectedUserId == action.id){
            //   state.selectedUserId = undefined;
            // }
            return organizationUserAdapter.removeOne(action.id, state);

        case actions.OrganizationUserActionTypes.DELETE_USERS:
            // if(action.ids.indexOf(state.selectedUserId) > -1){
            //   state.selectedUserId = undefined;
            // }
            return organizationUserAdapter.removeMany(action.ids, state);

        case actions.OrganizationUserActionTypes.DELETE_ALL_USERS:
            return organizationUserAdapter.removeMany(action.ids, state);

        case actions.OrganizationUserActionTypes.DELETE_ALL:
            return organizationUserAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getOrganizationUserState = createFeatureSelector<OrganizationUserState>('organizationUser');

export const { selectIds, selectEntities, selectAll, selectTotal } = organizationUserAdapter.getSelectors(getOrganizationUserState);

const getSelectedUserIdState = (state: OrganizationUserState) => {
    return state.selected_user_id;
};
export const getSelectedUserId = createSelector(getOrganizationUserState, getSelectedUserIdState);

export const getSelectedUser = createSelector(getOrganizationUserState, (state: OrganizationUserState) => {
    if (state.selected_user_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_user_id];
});
